import { Component, Input, OnInit } from '@angular/core';
import { CASHIER_METHODS_SELECT_MIN_COUNT } from '../../config/cashier.config';
import { EmitterService } from '../../../services/emitter.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent {

 @Input() selectorData = [];
  minimumListCount = CASHIER_METHODS_SELECT_MIN_COUNT;
  constructor(private emitterService:EmitterService) { }
  onChangeSelector(data){
    this.emitterService.broadCastPaymentMethod(data);
  }

}
